module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("registration.takanon.title")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "font-size": "14px",
      "text-align": "var(--src-position)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('registration.takanon.text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "backBtn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('inline-svg', {
    staticClass: "backs-svg",
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b923a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration/Takanon.vue
// module id = 498
// module chunks = 18